import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
  body {
    color: #000;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
  }

  a {
    text-decoration: none;
  }

  input, button {
    &:focus {
      outline: none;
    }
  }

  input.hasErrors, textarea.hasErrors {
    border: 1px #F43030 solid;
  }

  p.errorMessage {
    color: #F43030;
    font-size: small;
    text-align: center;
    margin-top: 3px;
  }
  
  p.fieldErrorMessage {
    color: #F43030;
    font-size: small;
    margin-top: 3px;
  }

  p.errorMessage::before {
    display: inline;
    content: "⚠ ";
  }

  p.noticeMessage {
    color: #B5B7C6;
    font-size: small;
    text-align: center;
    margin-top: 3px;
  }

  p.noticeMessage::before {
    display: inline;
    content: "⚠ ";
  }
  
  p.warningMessage {
    color: #f8ac59;
    font-size: small;
    text-align: center;
    margin-top: 3px;
  }

  p.warningMessage::before {
    display: inline;
    content: "⚠ ";
  }
  
  .showLessMore {
     padding-left: 60px;
     font-size: 12px;
     line-height: 30px;
     color: #0085FF;
  }
  
  .termsDesc {
     padding-left: 60px;
     font-size: 12px;
  }
  
  .center {
     text-align: center; 
  }
  
  .alertButtonDisabled {
     color: #ccc !important;
     pointer-events: none;
  }
  
  ion-searchbar:not(.listSearch) {
      margin-top: 20px;
  }
  
  ion-searchbar input {
      font-size: 12px !important;
      --background: #F4F4F9;
  }
  
  ion-tab-button {
      --background: #FFFFFF;
  }
    
  .action-sheet-button {
      font-size: 15px !important;
  }

  html.barcode-scanning-active,
  html.barcode-scanning-active body {
      background: transparent !important;
      --ion-background-color: transparent;
  }

  html.barcode-scanning-active ion-app,
  html.barcode-scanning-active ion-router-outlet,
  html.barcode-scanning-active ion-tabs,
  html.barcode-scanning-active ion-tab-bar,
  html.barcode-scanning-active ion-content,
  html.barcode-scanning-active .ion-page {
      background: transparent !important;
      --background: transparent !important;
      --ion-background-color: transparent;
  }

  html.barcode-scanning-fullscreen,
  html.barcode-scanning-fullscreen body {
      background: transparent !important;
      --ion-background-color: transparent;
  }

  html.barcode-scanning-fullscreen ion-app,
  html.barcode-scanning-fullscreen ion-router-outlet,
  html.barcode-scanning-fullscreen ion-tabs,
  html.barcode-scanning-fullscreen ion-tab-bar,
  html.barcode-scanning-fullscreen ion-content,
  html.barcode-scanning-fullscreen .ion-page,
  html.barcode-scanning-fullscreen ion-modal,
  html.barcode-scanning-fullscreen ion-backdrop {
      visibility: hidden !important;
      background: transparent !important;
      --background: transparent !important;
      --ion-background-color: transparent;
  }

  html.barcode-scanning-fullscreen .scanner-torch-button {
      visibility: visible !important;
      position: fixed;
      bottom: 40px;
      right: 20px;
      z-index: 99999;
  }

  html.barcode-scanning-fullscreen .scanner-close-button {
      visibility: visible !important;
      position: fixed;
      bottom: 40px;
      left: 20px;
      z-index: 99999;
  }

  html.barcode-scanning-fullscreen .scanner-barcode-overlay {
      visibility: visible !important;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99998;
      pointer-events: none;
  }

  .scanner-torch-button button,
  .scanner-close-button button {
      background: rgba(0, 0, 0, 0.5);
      border: none;
      border-radius: 50%;
      width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding-top: 4px;
  }


  .chose-other {
      display: flex;
      align-items: center;
      margin: 8px 0;

      hr {
          width: 100%;
          border-bottom: 1px solid #888A98;
      }

      .one-line {
          font-size: 11px;
          white-space: nowrap;
          padding: 0 8px;
      }
  }
`;

export default GlobalStyle;
